module.exports = __webpack_public_path__ + "img/calender-time.c00bf3b2.svg";